
import { useState } from "react"
import { teutonicOption, teutonicUpgrade } from "../../../../data/upgrade/teutonic"
import ListSelect from "../../ListSelect"
import Btn from "../../Btn"

const TeutonicUpgrade = (props) => {
    const selectList = teutonicOption
    const lvl = Array.from({ length: 20 }, (_, index) => ({ id: index + 1, name: `Level ${index + 1}` }));

    const [selectValue, setSelectValue] = useState({name:"", lvl:"1"})
    const handleSelectName = event => {
        setSelectValue(prevState => ({ name: event.target.value, lvl: prevState.lvl }));
    } 
    const handleSelectLvl = event => {
        setSelectValue(prevState => ({ ...prevState, lvl: event.target.value }));
    }
    
      
    function vypis(){
        const selectedTeutonicUpgrade = teutonicUpgrade[selectValue.name - 1][selectValue.lvl-1]
        const item =[{id:1,
                      name: teutonicOption[selectValue.name - 1].name + " " + selectedTeutonicUpgrade.level ,
                      wood: selectedTeutonicUpgrade.wood,
                      clay: selectedTeutonicUpgrade.clay,
                      iron: selectedTeutonicUpgrade.iron,
                      crop: selectedTeutonicUpgrade.crop,
                      all: selectedTeutonicUpgrade.all}]
        props.addItem(item[0])
    }
    

    
    return(
        <div>
            <ListSelect label="...choose a trop" selectList={selectList} handleSelectValue={handleSelectName} />
            <ListSelect label="...choose a level" selectList={lvl} handleSelectValue={handleSelectLvl}/>
            {selectValue ? (
            <Btn className="btn" type="submit" text="Add to result" onClick={vypis} />
        ) : null}
        </div>
    )
}
export default TeutonicUpgrade